import React, { useCallback, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress
} from '@mui/material';
import { useDropzone } from 'react-dropzone';
import { useFiles } from '../hooks/useFilesContext.js';

function UploadModal({ open, onClose }) {
  const { handleUpload, currentFolder, folders } = useFiles();
  const [isUploading, setIsUploading] = useState(false);

  const onDrop = useCallback(async (acceptedFiles) => {
    setIsUploading(true);
    try {
      await handleUpload(acceptedFiles);
      onClose();
    } finally {
      setIsUploading(false);
    }
  }, [handleUpload, onClose]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true
  });

  // Encontra o nome da pasta atual
  const currentFolderName = currentFolder 
    ? (() => {
        const folder = folders.find(folder => folder.id === currentFolder);
        return folder?.is_main ? 'Pasta Principal' : folder?.name || 'Pasta Principal';
      })()
    : 'Pasta Principal';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Upload de Arquivos</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          Enviando arquivos para: <strong>{currentFolderName}</strong>
        </Typography>
        <Box
          {...getRootProps()}
          sx={{
            border: '2px dashed #ccc',
            borderRadius: 2,
            p: 3,
            textAlign: 'center',
            cursor: isUploading ? 'default' : 'pointer',
            backgroundColor: isDragActive ? '#f0f0f0' : 'transparent',
            '&:hover': {
              backgroundColor: isUploading ? 'transparent' : '#f0f0f0'
            },
            position: 'relative'
          }}
        >
          <input {...getInputProps()} disabled={isUploading} />
          {isUploading ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
              <CircularProgress size={40} />
              <Typography>Enviando arquivos...</Typography>
            </Box>
          ) : (
            <Typography>
              {isDragActive
                ? 'Solte os arquivos aqui...'
                : 'Arraste e solte arquivos aqui, ou clique para selecionar'}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isUploading}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}

export default UploadModal; 